import { Shield, Award, CheckCircle } from 'lucide-react';

const TrustPhilosophySection = () => (
  <>
    <section className="py-12 md:py-16 bg-white" data-testid="trust-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          <div className="flex items-start p-6 bg-slate-50 rounded-xl border border-slate-100">
            <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-black/10 rounded-lg mr-4">
              <Shield className="h-6 w-6 text-primary" />
            </div>
            <div>
              <h3 className="font-heading text-lg font-semibold text-primary mb-1">Board Certified Urologist</h3>
              <p className="text-slate-600 text-sm">By National Board of Physicians and Surgeons</p>
            </div>
          </div>
          <div className="flex items-start p-6 bg-slate-50 rounded-xl border border-slate-100">
            <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-black/10 rounded-lg mr-4">
              <Award className="h-6 w-6 text-primary" />
            </div>
            <div>
              <h3 className="font-heading text-lg font-semibold text-primary mb-1">Patient Choice Award</h3>
              <p className="text-slate-600 text-sm">Proud recipient annually since 2008</p>
            </div>
          </div>
          <div className="flex items-start p-6 bg-slate-50 rounded-xl border border-slate-100">
            <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-black/10 rounded-lg mr-4">
              <CheckCircle className="h-6 w-6 text-primary" />
            </div>
            <div>
              <h3 className="font-heading text-lg font-semibold text-primary mb-1">Compassionate Doctor Award</h3>
              <p className="text-slate-600 text-sm">Proud recipient annually since 2010</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="py-16 md:py-20 bg-slate-50" data-testid="philosophy-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-primary mb-6">
          Havkin Urology Philosophy
        </h2>
        <p className="text-lg text-slate-700 leading-relaxed mb-6">
          Dr. Havkin and the team come to work with only one stated goal: Delivery of the Best, State of the Art, personalized and compassionate care from the 1st moment our relationship with the patient begins. We want our patients to feel safe, heard, comfortable, taken care of and at home when they come to our practice. You will always be heard and will never be rushed.
        </p>
        <p className="text-lg text-slate-600 leading-relaxed">
          Dr. Havkin provides total Urological care and explores patient's entire history to diagnose and correct any and all urological issues. Many a times patients will come to accept their maladies as the norm or as expected without realizing that improvement and normalization are feasible and often easily attainable when receiving proper diagnosis and care. We strive to identify your problem/problems and won't rest until we can make you better.
        </p>
      </div>
    </section>
  </>
);

export default TrustPhilosophySection;
